export default "__VITE_ASSET__43b17e3d__"